export default "__VITE_ASSET__D1hul89Z__"